export const REGULAR = 'REGULAR';
export const BONUS_HUNT = 'BONUS_HUNT';
export const JACKPOT_HUNT = 'JACKPOT_HUNT';
export const STREAMERS_CHOICE = 'STREAMERS_CHOICE';
export const BONUS_BUY = 'BONUS_BUY';

export const EVENT_LABEL_MAPPING = {
	[BONUS_HUNT]: 'Bonus Hunt',
	[JACKPOT_HUNT]: 'Jackpot Hunt',
	[STREAMERS_CHOICE]: 'Streamers Choice',
	[BONUS_BUY]: 'Bonus Buy'
};

export const eventTagDescriptionText = (eventType, translations) => {
	return eventType === BONUS_HUNT
		? translations.WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_DESCRIPTION
		: eventType === JACKPOT_HUNT
			? translations.WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_DESCRIPTION
			: eventType === STREAMERS_CHOICE
				? translations.WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_DESCRIPTION
				: eventType === BONUS_BUY
					? translations.WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_DESCRIPTION
					: ''; // eventType is missing
};

export const eventTagTitleText = (eventType, translations) => {
	return eventType === BONUS_HUNT
		? translations.WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT
		: eventType === JACKPOT_HUNT
			? translations.WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT
			: eventType === STREAMERS_CHOICE
				? translations.WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT
				: eventType === BONUS_BUY
					? translations.WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT
					: ''; // eventType is missing
};

const WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_TITLE = 'WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_TITLE';
const WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_DESCRIPTION = 'WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_DESCRIPTION';
const WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_TITLE = 'WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_TITLE';
const WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_DESCRIPTION = 'WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_DESCRIPTION';
const WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_TITLE = 'WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_TITLE';
const WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_DESCRIPTION = 'WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_DESCRIPTION';
const WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_TITLE = 'WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_TITLE';
const WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_DESCRIPTION =
	'WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_DESCRIPTION';
const WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_TITLE = 'WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_TITLE';
const WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_DESCRIPTION = 'WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_DESCRIPTION';
const WE_SPIN_DASHBOARD_EVENT_TYPE_TITLE = 'WE_SPIN_DASHBOARD_EVENT_TYPE_TITLE';
const WE_SPIN_DASHBOARD_EVENT_TYPE_SUBTITLE = 'WE_SPIN_DASHBOARD_EVENT_TYPE_SUBTITLE';
const WE_SPIN_DASHBOARD_EVENT_TYPE_BUTTON = 'WE_SPIN_DASHBOARD_EVENT_TYPE_BUTTON';
const WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT = 'WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT';
const WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT = 'WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT';
const WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT = 'WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT';
const WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT = 'WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT';
const WE_SPIN_BONUS_HUNT_INFO_TEXT = 'WE_SPIN_BONUS_HUNT_INFO_TEXT';

export const WE_SPIN_EVENT_TAG_ALL_TEXT_KEYS = [
	WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_TITLE,
	WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_DESCRIPTION,
	WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_TITLE,
	WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_DESCRIPTION,
	WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_TITLE,
	WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_DESCRIPTION,
	WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_TITLE,
	WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_DESCRIPTION,
	WE_SPIN_DASHBOARD_EVENT_TYPE_TITLE,
	WE_SPIN_DASHBOARD_EVENT_TYPE_SUBTITLE,
	WE_SPIN_DASHBOARD_EVENT_TYPE_BUTTON,
	WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT,
	WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT,
	WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT,
	WE_SPIN_BONUS_HUNT_INFO_TEXT,
	WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_TITLE,
	WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_DESCRIPTION,
	WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT
];

export const ALL_EVENT_TAGS = [
	{
		tag: REGULAR,
		textKey: WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_TITLE,
		description: WE_SPIN_EVENT_TAG_TEXT_KEY_REGULAR_DESCRIPTION
	},
	{
		tag: BONUS_HUNT,
		textKey: WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_TITLE,
		description: WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_HUNT_DESCRIPTION
	},
	{
		tag: JACKPOT_HUNT,
		textKey: WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_TITLE,
		description: WE_SPIN_EVENT_TAG_TEXT_KEY_JACKPOT_HUNT_DESCRIPTION
	},
	{
		tag: STREAMERS_CHOICE,
		textKey: WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_TITLE,
		description: WE_SPIN_EVENT_TAG_TEXT_KEY_STREAMERS_CHOICE_DESCRIPTION
	},
	{
		tag: BONUS_BUY,
		textKey: WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_TITLE,
		description: WE_SPIN_EVENT_TAG_TEXT_KEY_BONUS_BUY_DESCRIPTION
	}
];

export const EVENT_TAG_OPTIONS = [...ALL_EVENT_TAGS].map(({ tag, textKey, description }) => ({
	value: tag,
	labelTextKey: textKey,
	description
}));

const tagTransformations = {
	[BONUS_HUNT]: event => ({
		...event,
		durationInMinutes: Math.max(240, event.durationInMinutes)
	})
};

export const eventTagTransformer = event =>
	event.eventTags.reduce(
		(transformedEvent, tag) =>
			tagTransformations[tag] ? tagTransformations[tag](transformedEvent) : transformedEvent,
		event
	);
